/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuItemDto as DigiworkMaitreDPosDtoMenuItemsMenuItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';

export interface GetMenuItem$Params {
  menuItemId: string;
}

export function getMenuItem(http: HttpClient, rootUrl: string, params: GetMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuItem.PATH, 'get');
  if (params) {
    rb.path('menuItemId', params.menuItemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>;
    })
  );
}

getMenuItem.PATH = '/api/menu-categories/menu-items/{menuItemId}';
